import React from "react";
import {
  MapPin,
  Mail,
  Github,
  Linkedin,
  FileText,
  ArrowDown,
} from "lucide-react";
import { Button } from "@/components/ui/button";
import { portfolioData } from "@/data/mock";

const HeroSection = () => {
  const { personal } = portfolioData;

  const scrollToExperience = (e) => {
    e.preventDefault();
    const el = document.getElementById("experience");
    if (el) {
      const top = el.getBoundingClientRect().top + window.scrollY - 72;
      window.scrollTo({ top, behavior: "smooth" });
    }
  };

  return (
    <section id="hero" className="pt-28 pb-16 md:pt-36 md:pb-20">
      <div className="max-w-[864px] mx-auto px-4 md:px-6">
        <div className="hero-animate">
          <div className="flex items-center gap-2 text-[#6B7280] text-sm mb-6">
            <MapPin size={15} className="flex-shrink-0" />
            <span>{personal.location}</span>
          </div>

          <h1 className="text-[clamp(2.5rem,5vw,3.5rem)] font-bold text-[#0A0A0A] dark:text-white leading-[1.1] tracking-tight mb-4">
            {personal.name}
          </h1>

          <p className="text-lg md:text-xl text-[#2563EB] font-medium leading-snug mb-6">
            {personal.headline}
          </p>

          <p className="text-base md:text-[17px] text-[#6B7280] leading-relaxed max-w-[640px] mb-8 text-justify">
            {personal.summary}
          </p>

          <div className="flex items-center gap-2 text-sm text-[#0A0A0A] dark:text-white mb-8">
            <Mail size={16} className="text-[#6B7280] flex-shrink-0" />
            <a
              href={`mailto:${personal.email}`}
              className="hover:text-[#2563EB] transition-colors duration-200 underline-offset-4 hover:underline"
            >
              {personal.email}
            </a>
          </div>

          <div className="flex flex-wrap items-center gap-4">
            <Button
              variant="outline"
              size="lg"
              onClick={scrollToExperience}
              className="border-[#0A0A0A] text-[#0A0A0A] dark:border-white dark:text-white hover:bg-[#0A0A0A] hover:text-white dark:hover:bg-white dark:hover:text-[#0A0A0A] rounded-lg gap-2 text-sm font-medium"
            >
              Ver experiência
              <ArrowDown size={15} />
            </Button>

            <div className="flex items-center gap-1">
              <a
                href={personal.social.github}
                target="_blank"
                rel="noopener noreferrer"
                className="p-2.5 text-[#6B7280] hover:text-[#0A0A0A] dark:hover:text-white hover:bg-gray-100 dark:hover:bg-white/[0.06] rounded-lg transition-colors duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#2563EB]"
                aria-label="GitHub"
              >
                <Github size={19} />
              </a>
              <a
                href={personal.social.linkedin}
                target="_blank"
                rel="noopener noreferrer"
                className="p-2.5 text-[#6B7280] hover:text-[#0A0A0A] dark:hover:text-white hover:bg-gray-100 dark:hover:bg-white/[0.06] rounded-lg transition-colors duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#2563EB]"
                aria-label="LinkedIn"
              >
                <Linkedin size={19} />
              </a>
              <a
                href={personal.social.cv}
                target="_blank"
                rel="noopener noreferrer"
                className="p-2.5 text-[#6B7280] hover:text-[#0A0A0A] dark:hover:text-white hover:bg-gray-100 dark:hover:bg-white/[0.06] rounded-lg transition-colors duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#2563EB]"
                aria-label="Currículo PDF"
              >
                <FileText size={19} />
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
